import { render, staticRenderFns } from "./LichSuGiaiTriForm.vue?vue&type=template&id=3918be78"
import script from "./LichSuGiaiTriForm.vue?vue&type=script&lang=js"
export * from "./LichSuGiaiTriForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports